/* AP — sessiz ürün videosu oynatıcı (lazy + cihaza/ağa uyumlu).
   LAZY: video, ekrana ~700px kala indirilmeye başlar (hızlı başlasın), >=%35 görününce oynar,
         ekrandan çıkınca durur. Görünene kadar hiçbir şey indirmez (kartlarda poster bile yok).
   OTOMATİK OYNATMA yalnızca "oto" videolarda (kapaktaki video). "tus" videolar play düğmesiyle.
   KALİTE: dosya, videonun EKRANDA kapladığı gerçek piksele göre seçilir (genişlik × ekran yoğunluğu, en çok 2x);
         yavaş ağ ölçülürse bir kademe küçüğe iner. Ekrandan çok uzaklaşan video dosyayı bırakır (bellek/çözücü boşalır).
   UYUM: veri tasarrufu / 2G / 3G / "hareketi azalt" → otomatik oynatma kapalı (fotoğraf + düğme).
         iPhone Düşük Güç Modu otomatik oynatmayı reddederse o sayfada otomatik oynatma kapanır, düğme çalışır.
         Zayıf cihazda (az çekirdek/bellek) aynı anda oynayan sayısı sınırlanır; güçlü cihazda sınır yok.
         Ölçüm: ilk kare >4 sn'de gelirse ya da video sürekli takılırsa otomatik oynatma o oturum için kapanır.
   SES: tamamen kapalı (muted + volume 0, kontrol yok; geri açılmaya çalışılırsa kapatılır). */
(function () {
  'use strict';
  var nav = navigator, baglanti = nav.connection || {};
  var tip = baglanti.effectiveType || '';
  var AZALT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TASARRUF = !!baglanti.saveData || /(^|-)2g$/.test(tip);   // '3g' sayılmaz: Android Chrome gerçek 4G'de bile sık 3g bildirir; yavaşsa kademe/ölçüm zaten küçültür
  var cekirdek = nav.hardwareConcurrency || 8, bellek = nav.deviceMemory || 8;
  var KOTA = (cekirdek <= 2 || bellek <= 1) ? 1 : ((cekirdek <= 4 || bellek <= 2) ? 2 : Infinity);
  var UA = nav.userAgent || '';
  var APPLE = /iP(hone|ad|od)/.test(UA) || (/Safari/.test(UA) && !/Chrome|Chromium|CriOS|Android/.test(UA));
  var IO_VAR = 'IntersectionObserver' in window;
  var yavasOturum = false, kademe = 0;   // kademe: ölçülen yavaşlığa göre kaç boy küçük dosya seçilsin (0-2)
  try { yavasOturum = sessionStorage.getItem('ap_video_yavas') === '1'; kademe = +(sessionStorage.getItem('ap_video_kademe') || 0); } catch (e) {}
  if ((baglanti.downlink !== undefined && baglanti.downlink < 3) || tip === '3g') { kademe = Math.max(kademe, 1); }
  var otoAcik = IO_VAR && !TASARRUF && !yavasOturum;   // 'hareketi azalt' (Android 'animasyonları kaldır') artık otomatik oynatmayı KAPATMAZ: sessiz kısa video + her zaman durdur düğmesi var

  var oynayan = [];
  var gorunur = new Set();
  var gorulen = new WeakSet();
  var yavasSayac = 0;
  var reddedildi = false;   // telefon otomatik oynatmayı reddetti (ör. iPhone Düşük Güç Modu)

  function mod(v) { return v.getAttribute('data-ap-mod') || 'oto'; }
  function sustur(v) { v.muted = true; v.defaultMuted = true; v.volume = 0; }
  function kap(v) { return v.closest ? (v.closest('.product-item') || v.closest('.ap-video-kap')) : null; }
  function dugmeBul(v) { var k = kap(v); return k ? k.querySelector('[data-ap-video-btn]') : null; }

  // Düğme + görünüm videonun gerçek durumunu izler.
  function esitle(v) {
    var d = dugmeBul(v), oynuyor = !v.paused && !v.ended;
    if (oynuyor) { v.classList.add('ap-video--oynuyor'); } else { v.classList.remove('ap-video--oynuyor'); }
    if (d) {
      d.setAttribute('aria-pressed', oynuyor ? 'true' : 'false');
      d.setAttribute('aria-label', oynuyor ? 'Videoyu durdur' : 'Videoyu oynat');
    }
  }

  // Liquid yalnızca en yüksek mp4'ü (1080p, ~9 MB) verir. Küçük sürümler ürünün .js verisinde var:
  // oradan EN KÜÇÜK uygun dosyayı seçeriz (dikey 270x480 ≈ 10 kat hafif). Alınamazsa 1080p'ye düşer.
  var KATALOG = {};
  function katalog(handle) {
    if (KATALOG[handle]) { return KATALOG[handle]; }
    var onbellek = null;
    try { onbellek = JSON.parse(sessionStorage.getItem('apv2:' + handle) || 'null'); } catch (e) {}
    var zamanAsimi = new Promise(function (coz) { setTimeout(function () { coz({}); }, 6000); });
    KATALOG[handle] = onbellek ? Promise.resolve(onbellek)
      : Promise.race([
          fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (p) {
              var m = {};
              (p.media || []).forEach(function (x) {
                if (x.sources) {
                  var hls = x.sources.filter(function (s) { return s.format === 'm3u8'; })[0];
                  m[x.id] = { mp4: x.sources.filter(function (s) { return s.format === 'mp4'; }), hls: hls ? hls.url : '' };
                }
              });
              try { sessionStorage.setItem('apv2:' + handle, JSON.stringify(m)); } catch (e) {}
              return m;
            })
            .catch(function () { return {}; }),
          zamanAsimi
        ]);
    return KATALOG[handle];
  }
  // Ekranda kaplanan alanı (object-fit: cover) karşılayan EN KÜÇÜK dosya; sonra yavaşlık kademesi kadar küçüğe in.
  // %15'e kadar büyütme gözle fark edilmez, bu pay hafif dosyayı seçtirir.
  function uygun(liste, v, kd) {
    var mp4 = (liste || []).filter(function (s) { return s.width && s.height; })
      .sort(function (a, b) { return a.width * a.height - b.width * b.height; });
    if (!mp4.length) { return null; }
    var w = v.clientWidth || (v.parentNode && v.parentNode.clientWidth) || 0;
    var h = v.clientHeight || (v.parentNode && v.parentNode.clientHeight) || 0;
    if (!w) { return null; }
    var d = Math.min(window.devicePixelRatio || 1, 2) / 1.15;
    var i = mp4.length - 1;
    for (var j = 0; j < mp4.length; j++) {
      if (Math.max(w * d / mp4[j].width, h * d / mp4[j].height) <= 1) { i = j; break; }
    }
    return mp4[Math.max(0, i - (kd || 0))];
  }
  function enKucuk(liste, esik) {
    var en = null, enAlan = 1e12, buyuk = null, buyukAlan = 0;
    (liste || []).forEach(function (s) {
      var kisa = Math.min(s.width, s.height), alan = s.width * s.height;
      if (kisa >= esik && alan < enAlan) { en = s; enAlan = alan; }
      if (alan > buyukAlan) { buyuk = s; buyukAlan = alan; }
    });
    return en || buyuk;
  }

  // Ağ ve çözücü ısınsın: kaynağı ekrana yaklaşırken (ya da düğmeye uzanırken) ata. Söz, iş bitince çözülür.
  // 1080p yedeği YALNIZ hızlı masaüstünde kullanılır; telefonda/yavaşta küçük sürüm bulunamazsa
  // video hiç yüklenmez (fotoğraf kalır) — yavaş hatta en büyük dosyayı çekmek durumu kötüleştirir.
  function hazirla(v) {
    if (v.__sozum) { return v.__sozum; }
    v.__t0 = performance.now();
    v.__sozum = new Promise(function (coz) {
      var yedek = v.getAttribute('data-src');
      var handle = v.getAttribute('data-urun'), id = v.getAttribute('data-media-id');
      var sayfa = v.getAttribute('data-ap-video') === 'sayfa';
      var hizliMasaustu = window.innerWidth > 720 && otoAcik;
      // Ölçülen indirme hızı (Chrome/Android) düşükse büyük sürüme çıkma. Bilinmiyorsa masaüstü hızlı sayılır.
      var hizliAg = (baglanti.downlink === undefined) || baglanti.downlink >= 5;
      var esik = (sayfa && hizliMasaustu && hizliAg) ? 400 : 240;
      var ata = function (url, hls) {
        if (url) {
          v.preload = otoAcik ? 'auto' : 'metadata';
          if (otoAcik && mod(v) !== 'tus') { v.autoplay = true; }   // muted+playsinline+autoplay: Android'de en az reddedilen yol
          v.src = url;
          if (yedek && !hls) {   // küçük dosya açılmazsa (codec/ağ) yedeğe dön
            v.addEventListener('error', function yd() {
              v.removeEventListener('error', yd);
              if (v.getAttribute('src') !== yedek) { v.src = yedek; v.load(); if (oynayan.indexOf(v) >= 0) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } }
            });
          }
          if (hls) {   // HLS açılmazsa küçük mp4'e dön
            v.addEventListener('error', function geri() {
              v.removeEventListener('error', geri);
              if (hls.mp4) { v.src = hls.mp4; v.load(); if (oynayan.indexOf(v) >= 0) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } }
            });
          }
          v.load();
        }
        coz();
      };
      if (!handle || !id) { ata(hizliMasaustu ? yedek : null); return; }
      katalog(handle).then(function (m) {
        var e = m[id] || {};
        var liste = Array.isArray(e) ? e : (e.mp4 || []);
        var s = uygun(liste, v, kademe) || enKucuk(liste, esik);
        var kucukMp4 = (enKucuk(liste, 240) || {}).url;
        // Safari/iPhone: ürün sayfası videosu HLS ile — oynatıcı hıza göre kaliteyi kendisi seçer.
        if (APPLE && sayfa && e.hls) { ata(e.hls, { mp4: kucukMp4 }); return; }
        ata(s && s.url ? s.url : (hizliMasaustu ? yedek : null));
      });
    });
    return v.__sozum;
  }

  function yerAc(v) {
    if (oynayan.length < KOTA) { return true; }
    var merkez = window.innerHeight / 2;
    function uzak(x) { var r = x.getBoundingClientRect(); return Math.abs((r.top + r.bottom) / 2 - merkez); }
    var en = null, d = -1;
    oynayan.forEach(function (x) { var u = uzak(x); if (u > d) { d = u; en = x; } });
    if (en && uzak(v) < d) { durdur(en); return true; }
    return false;
  }

  function baslat(v, elle) {
    if (document.hidden || oynayan.indexOf(v) >= 0) { return; }
    if (!elle && (!otoAcik || v.__elleDurdu)) { return; }
    if (!elle && !yerAc(v)) { return; }
    sustur(v);
    if (elle) { v.__elleBasladi = true; v.__elleDurdu = false; }
    oynayan.push(v);
    if (elle) {   // jest anı: kaynak yoksa önbellekteki katalogdan ya da 1080p yedekten hemen ata, play()'i AYNI olayda çağır
      if (!v.getAttribute('src')) {
        var hd = v.getAttribute('data-urun'), mid = v.getAttribute('data-media-id'), yd0 = v.getAttribute('data-src'), url0 = null;
        try { var oc = JSON.parse(sessionStorage.getItem('apv2:' + hd) || 'null'); var e0 = oc && oc[mid]; var s0 = e0 && uygun(e0.mp4 || [], v, kademe); url0 = s0 && s0.url; } catch (x) {}
        if (!url0) { url0 = yd0; }
        if (url0) { v.preload = 'auto'; v.src = url0; v.load(); v.__sozum = Promise.resolve(); }
      }
      if (v.getAttribute('src')) {
        var p0 = v.play();
        if (p0 && p0.catch) { p0.catch(function () { oynayan = oynayan.filter(function (x) { return x !== v; }); esitle(v); }); }
        return;
      }
    }
    hazirla(v).then(function () {
      if (oynayan.indexOf(v) < 0 || document.hidden) { return; }
      if (!v.getAttribute('src')) { oynayan = oynayan.filter(function (x) { return x !== v; }); return; }
      var p = v.play();
      if (p && p.catch) {
        p.catch(function (h) {
          window.__apvHata = (h && h.name) + ': ' + (h && h.message);
          oynayan = oynayan.filter(function (x) { return x !== v; });
          // iPhone Düşük Güç Modu / tarayıcı politikası: otomatik oynatma reddedildi → bu sayfada denemeyi bırak
          if (!elle && h && h.name === 'NotAllowedError') { otoAcik = false; reddedildi = true; }
          esitle(v);
        });
      }
    });
  }

  // Ekrandan çok uzaklaşan video dosyasını bırakır: tarayıcı belleği ve donanım çözücüsü boşalır
  // (yalnızca durdurmak yetmiyor, özellikle iPhone'da). Geri yaklaşınca yeniden hazırlanır (dosya önbellekten gelir).
  function birak(v) {
    if (!v.getAttribute('src')) { return; }
    durdur(v);
    v.__elleBasladi = false;
    v.autoplay = false; v.removeAttribute('src');
    try { v.load(); } catch (e) {}
    v.__sozum = null;
    v.classList.remove('ap-video--oynuyor');
    esitle(v);
  }

  function durdur(v) {
    try { v.pause(); } catch (e) {}
    oynayan = oynayan.filter(function (x) { return x !== v; });
  }

  function yavasla() {
    if (!otoAcik) { return; }
    otoAcik = false;
    try { sessionStorage.setItem('ap_video_yavas', '1'); } catch (e) {}
    oynayan.slice().forEach(function (v) { if (!v.__elleBasladi) { durdur(v); } });
  }

  function izle(v) {
    v.addEventListener('volumechange', function () { if (!v.muted || v.volume > 0) { sustur(v); } });
    v.addEventListener('playing', function () {
      esitle(v);
      if (v.__t0 && !v.__olculdu) {
        v.__olculdu = true;
        var sure = performance.now() - v.__t0;
        if (sure > 2500 && kademe < 2) {   // yavaş başladı: sonraki videolar bir boy küçük dosya seçsin
          kademe++;
          try { sessionStorage.setItem('ap_video_kademe', String(kademe)); } catch (e) {}
        }
        if (sure > 4000 && !v.__elleBasladi && ++yavasSayac >= 2) { yavasla(); }
      }
    });
    v.addEventListener('pause', function () { esitle(v); });
    v.addEventListener('waiting', function () {
      v.__takilma = (v.__takilma || 0) + 1;
      // Oynarken takılıyor: önce kaliteyi bir boy düşür ve bu videoyu küçük dosyayla yeniden başlat
      if (v.__takilma === 2 && kademe < 2 && !v.__kucultuldu) {
        v.__kucultuldu = true; kademe++;
        try { sessionStorage.setItem('ap_video_kademe', String(kademe)); } catch (e) {}
        var elle = !!v.__elleBasladi, an = v.currentTime || 0;
        birak(v); v.__takilma = 0;
        v.addEventListener('loadedmetadata', function ilk() { v.removeEventListener('loadedmetadata', ilk); try { v.currentTime = an; } catch (e) {} });
        if (elle || gorunur.has(v)) { baslat(v, elle); }
        return;
      }
      if (v.__takilma >= 4 && !v.__elleBasladi) { v.__takilma = 0; if (++yavasSayac >= 2) { yavasla(); } else { durdur(v); } }
    });
  }

  var yakin = IO_VAR ? new IntersectionObserver(function (kayitlar) {
    kayitlar.forEach(function (k) { if (k.isIntersecting && (otoAcik || k.target.getAttribute('data-ap-video') === 'sayfa')) { hazirla(k.target); } });
  }, { rootMargin: '700px 0px' }) : null;

  var uzak = IO_VAR ? new IntersectionObserver(function (kayitlar) {
    kayitlar.forEach(function (k) { if (!k.isIntersecting) { birak(k.target); } });
  }, { rootMargin: '2000px 0px' }) : null;

  var gor = IO_VAR ? new IntersectionObserver(function (kayitlar) {
    kayitlar.forEach(function (k) {
      var v = k.target;
      if (k.isIntersecting) { gorunur.add(v); baslat(v, false); }
      else { gorunur.delete(v); if (!v.__elleBasladi) { durdur(v); } }
    });
  }, { threshold: 0.35 }) : null;

  function tara(kok) {
    var r = kok || document;
    var liste = r.querySelectorAll ? r.querySelectorAll('video[data-ap-video]') : [];
    Array.prototype.forEach.call(liste, function (v) {
      if (gorulen.has(v)) { return; }
      gorulen.add(v); sustur(v); izle(v);
      if (yakin && (mod(v) !== 'tus' || v.getAttribute('data-ap-video') === 'sayfa')) { yakin.observe(v); }
      if (gor && mod(v) !== 'tus') { gor.observe(v); }
      if (uzak) { uzak.observe(v); }
    });
  }

  // ---- Play / durdur düğmesi (kart ve ürün galerisi)
  function dugmedenVideo(d) { var k = kap(d); return k ? k.querySelector('video[data-ap-video]') : null; }
  document.addEventListener('click', function (e) {
    // Düğmeye ya da ürün sayfasındaki videonun kendisine dokununca/tıklayınca: oynat ↔ durdur
    var d = e.target.closest ? (e.target.closest('[data-ap-video-btn]') || e.target.closest('.ap-video-kap')) : null;
    if (!d) { return; }
    e.preventDefault(); e.stopPropagation();
    var v = dugmedenVideo(d);
    if (!v) { return; }
    if (!v.paused && !v.ended) { v.__elleDurdu = true; v.__elleBasladi = false; durdur(v); }
    else { v.classList.remove('ap-video--gizli'); baslat(v, true); }
  }, true);
  // Niyet algılanınca (üzerine gelme/dokunma) videoyu önceden hazırla → basınca hemen başlasın.
  ['mouseover', 'touchstart', 'focusin'].forEach(function (olay) {
    document.addEventListener(olay, function (e) {
      var d = e.target.closest ? e.target.closest('[data-ap-video-btn]') : null;
      if (d) { var v = dugmedenVideo(d); if (v) { hazirla(v); } }
    }, { passive: true, capture: true });
  });

  // ---- Kartta renk (swatch) üzerine gelince/dokununca video değil o rengin fotoğrafı görünsün.
  function swatchKart(el) {
    var o = el.closest ? el.closest('.product-item-options__list') : null;
    if (!o) { return null; }
    var k = o.closest('.product-item');
    return { liste: o, video: k ? k.querySelector('video[data-ap-video]') : null };
  }
  function gizle(v, evet) {
    if (!v) { return; }
    if (evet) { v.__geri = !v.paused; v.classList.add('ap-video--gizli'); durdur(v); }
    else { v.classList.remove('ap-video--gizli'); if (v.__geri) { v.__geri = false; baslat(v, !!v.__elleBasladi); } }
  }
  document.addEventListener('mouseover', function (e) { var x = swatchKart(e.target); if (x) { gizle(x.video, true); } }, true);
  document.addEventListener('mouseout', function (e) {
    var x = swatchKart(e.target);
    if (x && !x.liste.contains(e.relatedTarget)) { gizle(x.video, false); }
  }, true);
  document.addEventListener('touchstart', function (e) { var x = swatchKart(e.target); if (x) { gizle(x.video, true); } }, true);

  // Otomatik oynatma reddedildiyse: ziyaretçinin İLK dokunuşunda ekrandaki videoları o dokunuşun içinde başlat
  // (telefonlar kullanıcı hareketiyle başlatılan oynatmaya izin verir). Sonra otomatik oynatmayı yeniden dener.
  function dokunusla() {
    if (!reddedildi) { return; }
    reddedildi = false; otoAcik = IO_VAR && !TASARRUF && !yavasOturum;
    gorunur.forEach(function (v) {
      if (v.__elleDurdu || !v.getAttribute('src')) { baslat(v, false); return; }
      sustur(v);
      if (oynayan.indexOf(v) < 0) { oynayan.push(v); }
      var p = v.play();
      if (p && p.catch) { p.catch(function () { oynayan = oynayan.filter(function (x) { return x !== v; }); reddedildi = true; otoAcik = false; }); }
    });
  }
  document.addEventListener('touchend', dokunusla, { passive: true, capture: true });
  document.addEventListener('click', dokunusla, true);

  // ?apdebug=1 → ekranın altında durum şeridi (Android'de neden oynamadığını görmek için)
  if (/[?&]apdebug=1/.test(location.search)) {
    var dbg = document.createElement('div');
    dbg.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;background:#000c;color:#0f0;font:11px/1.35 monospace;padding:6px 8px;white-space:pre-wrap;pointer-events:none';
    document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(dbg); });
    setInterval(function () {
      var v = document.querySelector('video[data-ap-video]');
      dbg.textContent = 'tip=' + tip + ' saveData=' + !!baglanti.saveData + ' downlink=' + baglanti.downlink + ' azalt=' + AZALT + ' kota=' + KOTA + '\n'
        + 'otoAcik=' + otoAcik + ' reddedildi=' + reddedildi + ' yavasOturum=' + yavasOturum + ' kademe=' + kademe + ' io=' + IO_VAR + '\n'
        + 'hata=' + (window.__apvHata || '-') + '\n'
        + (v ? ('video paused=' + v.paused + ' rs=' + v.readyState + ' ns=' + v.networkState + ' autoplay=' + v.autoplay + ' src=' + (v.currentSrc || v.getAttribute('src') || '-').slice(-28) + ' err=' + (v.error ? v.error.code : '-')) : 'video yok');
    }, 700);
  }

  // Sekme gizlenince hepsi dursun; dönünce kaldığı yerden.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { oynayan.slice().forEach(function (v) { v.__geri2 = true; durdur(v); }); }
    else {
      Array.prototype.forEach.call(document.querySelectorAll('video[data-ap-video]'), function (v) {
        if (v.__geri2) { v.__geri2 = false; baslat(v, !!v.__elleBasladi); }
      });
      gorunur.forEach(function (v) { baslat(v, false); });
    }
  });

  // Sonradan eklenen kartlar (slider, hızlı görünüm, sayfalama)
  var bekliyor = false;
  new MutationObserver(function () {
    if (bekliyor) { return; }
    bekliyor = true;
    requestAnimationFrame(function () { bekliyor = false; tara(document); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { tara(document); }); }
  else { tara(document); }
})();
